import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { OrganizationIntegrationResponseDto } from '@domain/organization-integration/dtos/organization-integration.response.dto';
import { CreateOrganizationIntegrationRequestDto } from '@domain/organization-integration/dtos/create-organization-integration.request.dto';
import { ListOrganizationIntegrationRequestDto } from '@domain/organization-integration/dtos/list-organization-integration.request.dto';
import { UpdateOrganizationIntegrationRequestDto } from '@domain/organization-integration/dtos/update-organization-integration.request.dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationIntegrationService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('organization/integration');
  }

  create(request: CreateOrganizationIntegrationRequestDto) {
    const queryUrl = `${this.getApiUrl()}`;
    return this.http.post<ApiResponse<OrganizationIntegrationResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateOrganizationIntegrationRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<OrganizationIntegrationResponseDto>>(queryUrl, body);
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<OrganizationIntegrationResponseDto>>(queryUrl, {});
  }

  list(request: ListOrganizationIntegrationRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<ApiResponse<PageableResponse<OrganizationIntegrationResponseDto>>>(
      queryUrl,
      { params: { ...request } },
    );
  }
}
